import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Tenant, TenantInput, VatType } from '../../entities/tenant/tenant';
import { LoadingService } from '../../services/loading.service';
import { TenantsService } from '../../services/tenants/tenants.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';

@Component({
  selector: 'app-tenant-dialog',
  templateUrl: './tenant-dialog.component.html',
  styleUrls: ['./tenant-dialog.component.scss']
})
export class TenantDialogComponent
  implements EditDialogInstance {

  tenant: Tenant;
  tenantFormGroup: FormGroup;
  vatTypeOptions: any[];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public tenantService: TenantsService,
    public loadingService: LoadingService
  ) {
    if (this.config.data) {
      this.tenant = this.config.data;
    }
    this.vatTypeOptions = tenantService.getVatTypes();
    this.tenantFormGroup = new FormGroup({});
    // // add form controls
    this.tenantFormGroup.addControl('id', new FormControl());
    this.tenantFormGroup.addControl('name', new FormControl(undefined, Validators.required));
    this.tenantFormGroup.addControl('additionalName', new FormControl());
    this.tenantFormGroup.addControl('description', new FormControl());
    this.tenantFormGroup.addControl('email', new FormControl(undefined, [Validators.required, Validators.email]));
    this.tenantFormGroup.addControl('phone', new FormControl());
    this.tenantFormGroup.addControl('addressLine0', new FormControl(undefined, Validators.required));
    this.tenantFormGroup.addControl('addressLine1', new FormControl());
    this.tenantFormGroup.addControl('postalCode', new FormControl(undefined, Validators.required));
    this.tenantFormGroup.addControl('city', new FormControl(undefined, Validators.required));
    this.tenantFormGroup.addControl('country', new FormControl(undefined, Validators.required));
    this.tenantFormGroup.addControl('vatNumber', new FormControl( undefined, [Validators.required, this.tenantService?.vatNumberValidator()]));
    this.tenantFormGroup.addControl('vatType', new FormControl( undefined, Validators.required));
    this.tenantFormGroup.addControl('paymentProviderEnabled', new FormControl());
    this.tenantFormGroup.addControl('paymentProviderId', new FormControl());
    this.tenantFormGroup.addControl('isNexatoTenant', new FormControl());

    if(this.tenant){
      this.tenantFormGroup.patchValue(this.tenant);
    }
  }

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {

    this.loadingService.setLoading(true);
    if(this.tenant){
      // its an update
      // for an update we must add the address to the input: the address gets added/modified in its own dialog
      // if we do not add the address, it will be deleted
      let tenantInput = new TenantInput(this.tenantFormGroup.value);
      this.tenantService.updateTenant(tenantInput, (result: any) => {
        this.ref.close(true);
      });
    } else {
      // its a create
      let tenantInput = new TenantInput(this.tenantFormGroup.value);
      this.tenantFormGroup.disable();
      this.tenantService.createTenant( tenantInput, (result: any) => {
        this.ref.close(result.data.createTenant.id);
      });
    }
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.tenantFormGroup;
  }


}
